import '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader/bcheader.scss';
import type { BowlingCenterContent } from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/schema';

interface Navigation {
  navigation: any;
}

export default function SearchNavigation(navigation: Navigation) {
  const backurl = navigation.navigation?.backurl;
  const prevurl = navigation.navigation?.prevurl;
  const nexturl = navigation.navigation?.nexturl;
  const current = navigation.navigation?.current;
  const total = navigation.navigation?.total;
  return (
    <div className="search-navigation">
      <div className="back-to-search">
        {backurl && (
          <a href={backurl} className="back-search-link">
            <span className="search-back-text">Back to search</span>
          </a>
        )}
      </div>
      <div className="search-prev-next">
        <div className="search-prev">
          {prevurl && (
            <a href={prevurl} className="search-link-prev">
              <span className="search-prev-text">Previous</span>
            </a>
          )}
        </div>
        {current && (
          <div className="search-current">
            {current}/{total}
          </div>
        )}
        <div className="search-next">
          {nexturl && (
            <a href={nexturl} className="search-link-next">
              <span className="search-next-text">Next</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
